<template>
  <div class="mine-balance-box">
    <van-row>
      <van-col span="8"> 总资产 </van-col>
      <van-col span="8" style="text-align: center" @click="toDotransall">
        一键回收
      </van-col>
      <van-col span="8" style="text-align: right">保险箱</van-col>
      <van-col span="12">
        <span style="font-size: 0.6rem; font-weight: 700">{{
          safeUsr.balance
        }}</span>
      </van-col>
      <van-col span="12" style="text-align: right">
        <span style="font-size: 0.6rem; font-weight: 700">{{
          safeUsr.lock_amount
        }}</span>
      </van-col>
    </van-row>
    <div style="margin-top: 18px; font-size: 0.35rem; text-align: right">
      <span @click="$router.push({ name: 'turnover'});">流水记录<van-icon name="arrow" /></span>
    </div>
    <van-row class="balance-count">
      <van-col span="6"
        >投注总额
        <p class="van-ellipsis">
          {{ record.total_bet }}
        </p>
      </van-col>
      <van-col span="6"
        >输赢总额
        <p class="van-ellipsis">{{ record.total_win_loss }}</p>
      </van-col>
      <van-col span="6"
        >有效投注
        <p class="van-ellipsis">{{ record.total_valid_bet }}</p>
      </van-col>
      <van-col span="6"
        >投注次数
        <p class="van-ellipsis">{{ record.total_count }}</p>
      </van-col>
    </van-row>
  </div>
</template>

<script>
export default {
  name: 'MineBalanceView',
  props: ['usr'],
  computed: {
    safeUsr () {
      return this.usr || {}
    }
  },
  data () {
    return {
      record: {}
    }
  },
  mounted () {
    this.getusrBetrecord()
  },
  methods: {
    async getusrBetrecord () {
      await this.$http({
        method: 'post',
        url: 'usrBetrecord',
        data: { api_type: '', date: '4', page: 1 }
      }).then(data => {
        this.record = data.data.summary
      })
    },
    async toDotransall () {
      await this.$http({
        method: 'post',
        url: 'dotransall'
      }).then(data => {
        this.$toast.success(data.msg)
        this.$emit('refresh')
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.mine-balance-box {
  color: rgb(74, 41, 0);
  background-image: url(../../../assets/images/card2.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 20px;
  text-align: left;
  line-height: 1.8;
  .balance-count {
    border-top: 1px solid rgb(74, 41, 0);
    text-align: center;
    padding-top: 15px;
    line-height: 1.8;
    p {
      font-size: 0.35rem;
      font-weight: 600;
    }
  }
}
</style>
